import axios from "axios";
import {getAuthToken} from "./utility";
import * as Constants from "./Constants";

// Request interceptor — automatically attaches JWT auth header to every request
axios.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `${Constants.BEARER}${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Public auth endpoints where a 401 means a credential/OTP failure (wrong password,
// bad/expired OTP) — NOT an expired session. These must be handled inline by the
// caller, never trigger a session-clear + redirect. Mirrors the Android client's
// RetrofitClient.isPublicAuthPath. (refresh is intentionally NOT exempt.)
const PUBLIC_AUTH_401 =
  /\/auth\/v1\/(authenticate|getUserRole|forgot-password\/|request-whatsapp-otp|verify-whatsapp-otp)/;

// Response interceptor — centralized handling for auth failures
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || "";
    if (error.response?.status === 401 && !PUBLIC_AUTH_401.test(url)) {
      localStorage.clear();
      window.location.href = "/"; // expired session — bounce to landing/sign-in
    }
    return Promise.reject(error);
  }
);

export default axios;
